import { NotificationDefinition } from '../../types'
import { QuotePdfGenerationFailedHeader } from './QuotePdfGenerationFailedHeader'
import { QuotePdfGenerationFailedListItem } from './QuotePdfGenerationFailedListItem'
import { QuotePdfGenerationFailedPreview } from './QuotePdfGenerationFailedPreview'

export const quotePdfGenerationFailedDefinition: NotificationDefinition = {
  listItemContent: QuotePdfGenerationFailedListItem,
  previewHeaderContent: QuotePdfGenerationFailedHeader,
  previewContent: QuotePdfGenerationFailedPreview
}
